import { Field, Select } from "@/components/FormField";

const NURSERIES = ["Choudhury Nursery", "Green Valley Nursery", "Other Verified Nursery"];
const PURPOSES = [
  "Browse Plants", "Purchase Plants", "Bulk Plant Purchase", "Inspect Plant Quality",
  "Discuss Pricing", "Discuss Project Supply", "Other",
];

export default function NurseryVisitFields({ form, upd, extra, updExtra }) {
  return (
    <>
      <div className="text-sm font-semibold text-[var(--yp-primary)] sm:col-span-2 -mb-2">Nursery Visit Information</div>
      <Select id="sr-nursery" label="Choose nursery" required value={form.selected_nursery} onChange={(v) => upd("selected_nursery", v)} options={NURSERIES} className="sm:col-span-2" />
      <Select id="sr-nursery-purpose" label="Purpose of visit" value={extra.purpose || ""} onChange={(v) => updExtra("purpose", v)} options={PURPOSES} />
      <Field id="sr-nursery-plants" label="Plants you are looking for" value={extra.plants_wanted || ""} onChange={(v) => updExtra("plants_wanted", v)} placeholder="Plant name, category or variety" />
      <Field id="sr-nursery-qty" label="Expected quantity" type="number" value={extra.qty || ""} onChange={(v) => updExtra("qty", v)} />
      <Field id="sr-nursery-note" label="Any special requirement?" value={extra.note || ""} onChange={(v) => updExtra("note", v)} placeholder="Size, variety, budget, availability..." />
    </>
  );
}
